// Every navigate, link and breadcrumb in this module reads its path and its
// entity labels from here, so a rename is one edit.
export default {
    entityKey: 'products',
    basePath: '/products',
    titles: {
        singular: 'Product',
        plural: 'Products',
    },
};
